// src/utils/loadGoogleMapsScript.js
const loadGoogleMapsScript = async () => {
  try {
    await new Promise((resolve, reject) => {
      if (!window.google) {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&libraries=places`;
        script.async = true;
        script.onload = () => {
          setTimeout(resolve, 100);
        };
        script.onerror = reject;
        document.head.appendChild(script);
      } else {
        resolve();
      }
    });
    return window.google;
  } catch (error) {
    console.error('Error loading Google Maps:', error);
    throw error;
  }
};

export default loadGoogleMapsScript;